import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import * as i3 from 'base-consulate-address-library';
import { BaseConsulateAddressLibraryService } from 'base-consulate-address-library';
import * as i1 from '@ngrx/store';
import * as i2 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'cache-country-list';
import * as i6 from 'app-services-library';
import * as i7 from '@angular/common';
import * as i8 from '@angular/forms';
import * as i9 from 'primeng/divider';
import * as i10 from 'primeng/radiobutton';
import * as i11 from 'primeng/dropdown';
import * as i12 from 'primeng/table';
import * as i13 from 'primeng/api';
import * as i14 from 'primeng/inputtext';
import * as i15 from 'primeng/button';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';

class ConsulateAddressLibraryService {
    constructor() { }
}
ConsulateAddressLibraryService.ɵfac = function ConsulateAddressLibraryService_Factory(t) { return new (t || ConsulateAddressLibraryService)(); };
ConsulateAddressLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: ConsulateAddressLibraryService, factory: ConsulateAddressLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsulateAddressLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["processingInformationForm"];
function ConsulateAddressLibraryComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 14);
    i0.ɵɵtext(2, "Check here");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " for USCIS filing address links. ");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("href", ctx_r0.directFilingAddress, i0.ɵɵsanitizeUrl);
} }
function ConsulateAddressLibraryComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "p-radioButton", 16);
    i0.ɵɵlistener("onClick", function ConsulateAddressLibraryComponent_div_10_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.officeTypeToggle(ctx_r9.typeOfOffice); })("ngModelChange", function ConsulateAddressLibraryComponent_div_10_Template_p_radioButton_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.typeOfOffice = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const officeType_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", officeType_r8)("ngModel", ctx_r1.typeOfOffice);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", officeType_r8.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(officeType_r8.name);
} }
function ConsulateAddressLibraryComponent_div_14_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "th", 30);
    i0.ɵɵelementStart(2, "th");
    i0.ɵɵtext(3, "Consulate Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 31);
    i0.ɵɵtext(5, "Consulate Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ConsulateAddressLibraryComponent_div_14_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelement(2, "p-tableRadioButton", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 31);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r13.disabledControls)("value", item_r16);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r16 == null ? null : item_r16.consulateName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r16 == null ? null : item_r16.consulateAddress);
} }
function ConsulateAddressLibraryComponent_div_14_p_divider_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider");
} }
function ConsulateAddressLibraryComponent_div_14_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵtext(2, "Selected Consulate:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵelementStart(4, "h6");
    i0.ɵɵelementStart(5, "b");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r15.selectedConsulateAddress == null ? null : ctx_r15.selectedConsulateAddress.consulateName);
} }
function ConsulateAddressLibraryComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "h6", 19);
    i0.ɵɵtext(2, "Consulate Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵelementStart(4, "div", 21);
    i0.ɵɵelementStart(5, "label", 22);
    i0.ɵɵtext(6, "Select Country for consulate list");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "p-dropdown", 23);
    i0.ɵɵlistener("ngModelChange", function ConsulateAddressLibraryComponent_div_14_Template_p_dropdown_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.countryCode = $event; })("onChange", function ConsulateAddressLibraryComponent_div_14_Template_p_dropdown_onChange_7_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.onChangeCountry(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 24);
    i0.ɵɵelementStart(9, "div", 25);
    i0.ɵɵelementStart(10, "p-table", 26);
    i0.ɵɵlistener("onRowSelect", function ConsulateAddressLibraryComponent_div_14_Template_p_table_onRowSelect_10_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.onRowSelect($event); })("selectionChange", function ConsulateAddressLibraryComponent_div_14_Template_p_table_selectionChange_10_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.selectedConsulateAddress = $event; });
    i0.ɵɵtemplate(11, ConsulateAddressLibraryComponent_div_14_ng_template_11_Template, 6, 0, "ng-template", 27);
    i0.ɵɵtemplate(12, ConsulateAddressLibraryComponent_div_14_ng_template_12_Template, 7, 4, "ng-template", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, ConsulateAddressLibraryComponent_div_14_p_divider_13_Template, 1, 0, "p-divider", 2);
    i0.ɵɵtemplate(14, ConsulateAddressLibraryComponent_div_14_div_14_Template, 7, 1, "div", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("options", ctx_r3.listCountry)("ngModel", ctx_r3.countryCode);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r3.consulateAddress)("selection", ctx_r3.selectedConsulateAddress);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.selectedConsulateAddress);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.selectedConsulateAddress);
} }
function ConsulateAddressLibraryComponent_div_15_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.getGlobalErrorMessages("REQUIRED"), " ");
} }
function ConsulateAddressLibraryComponent_div_15_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.getGlobalErrorMessages("REQUIRED"), " ");
} }
function ConsulateAddressLibraryComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵelementStart(2, "label", 38);
    i0.ɵɵtext(3, "Office Address (City)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 39, 40);
    i0.ɵɵlistener("ngModelChange", function ConsulateAddressLibraryComponent_div_15_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.officeAddressCity = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ConsulateAddressLibraryComponent_div_15_span_6_Template, 2, 1, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 37);
    i0.ɵɵelementStart(8, "label", 38);
    i0.ɵɵtext(9, "U.S State or Foreign Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "input", 42, 43);
    i0.ɵɵlistener("ngModelChange", function ConsulateAddressLibraryComponent_div_15_Template_input_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.usStateOrForiegnCountry = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, ConsulateAddressLibraryComponent_div_15_span_12_Template, 2, 1, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = i0.ɵɵreference(5);
    const _r24 = i0.ɵɵreference(11);
    const ctx_r4 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(13);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r4.disabledControls)("ngModel", ctx_r4.officeAddressCity);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (_r22.touched || _r2.submitted) && (_r22.errors == null ? null : _r22.errors.required));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r4.disabledControls)("ngModel", ctx_r4.usStateOrForiegnCountry);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (_r24.touched || _r2.submitted) && (_r24.errors == null ? null : _r24.errors.required));
} }
function ConsulateAddressLibraryComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "h6", 19);
    i0.ɵɵtext(2, "Beneficiary's Foreign Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 46);
    i0.ɵɵelementStart(4, "div", 47);
    i0.ɵɵelementStart(5, "div", 48);
    i0.ɵɵelementStart(6, "p", 49);
    i0.ɵɵtext(7, "Address 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label", 50);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 48);
    i0.ɵɵelementStart(11, "p", 49);
    i0.ɵɵtext(12, "Address 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "label", 50);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 51);
    i0.ɵɵelementStart(16, "p", 49);
    i0.ɵɵtext(17, "Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "label", 50);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 51);
    i0.ɵɵelementStart(21, "p", 49);
    i0.ɵɵtext(22, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "label", 50);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 51);
    i0.ɵɵelementStart(26, "p", 49);
    i0.ɵɵtext(27, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "label", 50);
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 51);
    i0.ɵɵelementStart(31, "p", 49);
    i0.ɵɵtext(32, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "label", 50);
    i0.ɵɵtext(34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 51);
    i0.ɵɵelementStart(36, "p", 49);
    i0.ɵɵtext(37, "Zip / Postal code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "label", 50);
    i0.ɵɵtext(39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate((ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.addressLine1) ? ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.addressLine1 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.addressLine2) ? ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.addressLine2 : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.locality) ? ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.locality : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.country == null ? null : ctx_r5.beneficiaryAddress.country.countryName) || (ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.countryCode == null ? null : ctx_r5.beneficiaryAddress.countryCode.countryName) || "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.stateProvinceCode) || (ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.stateProvinceName) ? (ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.stateProvinceName) || (ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.stateProvinceCode) : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.city) ? ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.city : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.postCode) ? ctx_r5.beneficiaryAddress == null ? null : ctx_r5.beneficiaryAddress.postCode : "--");
} }
function ConsulateAddressLibraryComponent_button_21_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 52);
    i0.ɵɵlistener("click", function ConsulateAddressLibraryComponent_button_21_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.postProcessingInformation(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngClass", _r2.invalid || ctx_r6.disabledControls ? "btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn btn-primary" : "btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn btn-primary")("disabled", _r2.invalid || ctx_r6.disabledControls);
} }
function ConsulateAddressLibraryComponent_button_22_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 52);
    i0.ɵɵlistener("click", function ConsulateAddressLibraryComponent_button_22_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.postProcessingInformation(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", (ctx_r7.typeOfOffice == null ? null : ctx_r7.typeOfOffice.value) !== "" && (ctx_r7.officeAddressCity === "" || ctx_r7.usStateOrForiegnCountry === "" || ctx_r7.disabledControls) ? "btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn btn-primary" : "btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn btn-primary")("disabled", (ctx_r7.typeOfOffice == null ? null : ctx_r7.typeOfOffice.value) !== "" && (ctx_r7.officeAddressCity === "" || ctx_r7.usStateOrForiegnCountry === "" || ctx_r7.disabledControls));
} }
class ConsulateAddressLibraryComponent extends BaseConsulateAddressLibraryService {
    constructor(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, cacheCountryService, appServicesLibraryService) {
        super(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, cacheCountryService, appServicesLibraryService);
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.cacheCountryService = cacheCountryService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
        this.isWizard = false;
    }
    ngAfterViewInit() {
        super.loadAfterViewInit();
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        this.isWizardFalg = this.isWizard;
        super.loadInit();
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
ConsulateAddressLibraryComponent.ɵfac = function ConsulateAddressLibraryComponent_Factory(t) { return new (t || ConsulateAddressLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3.APIConsulateAddress), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.CacheCountryListService), i0.ɵɵdirectiveInject(i6.AppServicesLibraryService)); };
ConsulateAddressLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConsulateAddressLibraryComponent, selectors: [["consulate-address-library"]], viewQuery: function ConsulateAddressLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.processingInformationForm = _t.first);
    } }, inputs: { primaryData: "primaryData", isWizard: "isWizard" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 23, vars: 7, consts: [[1, "col-md-12", "mb-4"], [1, "mb-0"], [4, "ngIf"], [1, "row", "col-md-12", "pr-0", "mb-2"], [1, "row", "col-md-12", "p-0"], ["class", "each-office-type", 4, "ngFor", "ngForOf"], [1, "mt-2"], ["processingInformationForm", "ngForm"], ["class", "consulate-address-section col-md-12 mt-4", 4, "ngIf"], ["class", "office-country-section row col-md-12 mt-4", 4, "ngIf"], ["class", "beneficiary-address-section col-md-12 mt-4", 4, "ngIf"], [1, "row"], [1, "col-md-3", "mb-md-5"], ["pButton", "", "type", "submit", "label", "Save", 3, "ngClass", "disabled", "click", 4, "ngIf"], ["target", "_blank"], [1, "each-office-type"], ["name", "officeType", 3, "value", "ngModel", "onClick", "ngModelChange"], [1, "m-0", "pl-2", 3, "for"], [1, "consulate-address-section", "col-md-12", "mt-4"], [1, "heading"], [1, "p-fluid", "p-formgrid", "p-grid", "px-3", "py-2"], [1, "p-col-8"], ["for", "tasktype", 1, "create-task-label"], ["inputId", "tasktype", "styleClass", "redBorder", "name", "countryCode", "placeholder", "Select Country", "optionLabel", "countryName", "optionValue", "countryCode", 3, "options", "ngModel", "ngModelChange", "onChange"], [1, "row", "mt-2"], [1, "col-md-12", "pr-0"], [1, "uscis-table", "table-striped-simple", 3, "value", "selection", "onRowSelect", "selectionChange"], ["pTemplate", "header"], ["pTemplate", "body"], ["class", "row pr-0", 4, "ngIf"], [2, "width", "3rem"], ["colspan", "2"], [3, "disabled", "value"], [1, "row", "pr-0"], [1, "col-md-12"], [1, "col-md-12", "pt-1"], [1, "office-country-section", "row", "col-md-12", "mt-4"], [1, "col-6"], [1, "required"], ["pInputText", "", "type", "text", "name", "officeAddress", "placeholder", "Ex: San Francisco", "required", "", 1, "im-input", 3, "disabled", "ngModel", "ngModelChange"], ["officeAddress", "ngModel"], ["class", "invalid-message", 4, "ngIf"], ["pInputText", "", "type", "text", "name", "usStateOrForiegnCountryAddress", "placeholder", "Ex: California", "required", "", 1, "im-input", 3, "disabled", "ngModel", "ngModelChange"], ["usStateOrForiegnCountryAddress", "ngModel"], [1, "invalid-message"], [1, "beneficiary-address-section", "col-md-12", "mt-4"], [1, "beneficiary-address-form"], [1, "row", "row-cols-5"], [1, "col", "mb-2", "word-wrap"], [1, "label-light", "m-0"], [1, "label-dark"], [1, "col", "mb-2"], ["pButton", "", "type", "submit", "label", "Save", 3, "ngClass", "disabled", "click"]], template: function ConsulateAddressLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h4", 1);
        i0.ɵɵtext(2, "Processing Information");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, ConsulateAddressLibraryComponent_ng_container_3_Template, 4, 1, "ng-container", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "p");
        i0.ɵɵtext(6, "Choose how you want to be notified if this petition is approved. This is applicable ONLY IF the beneficiary is outside the US OR a requested extension of stay OR change of status cannot be granted.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵelementStart(8, "span");
        i0.ɵɵtext(9, "Type of office:");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, ConsulateAddressLibraryComponent_div_10_Template, 4, 4, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div");
        i0.ɵɵelementStart(12, "form", 6, 7);
        i0.ɵɵtemplate(14, ConsulateAddressLibraryComponent_div_14_Template, 15, 6, "div", 8);
        i0.ɵɵtemplate(15, ConsulateAddressLibraryComponent_div_15_Template, 13, 6, "div", 9);
        i0.ɵɵelement(16, "p-divider");
        i0.ɵɵtemplate(17, ConsulateAddressLibraryComponent_div_17_Template, 40, 7, "div", 10);
        i0.ɵɵelement(18, "p-divider");
        i0.ɵɵelementStart(19, "div", 11);
        i0.ɵɵelementStart(20, "div", 12);
        i0.ɵɵtemplate(21, ConsulateAddressLibraryComponent_button_21_Template, 1, 2, "button", 13);
        i0.ɵɵtemplate(22, ConsulateAddressLibraryComponent_button_22_Template, 1, 2, "button", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.directFilingAddress);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngForOf", ctx.officeTypeOptions);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", (ctx.typeOfOffice == null ? null : ctx.typeOfOffice.value) === "Consulate");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.typeOfOffice == null ? null : ctx.typeOfOffice.value) !== "Consulate" && (ctx.typeOfOffice == null ? null : ctx.typeOfOffice.value) !== "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.typeOfOffice == null ? null : ctx.typeOfOffice.value) !== "");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", (ctx.typeOfOffice == null ? null : ctx.typeOfOffice.value) === "Consulate");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.typeOfOffice == null ? null : ctx.typeOfOffice.value) !== "Consulate");
    } }, directives: [i7.NgIf, i7.NgForOf, i8.ɵangular_packages_forms_forms_ba, i8.NgControlStatusGroup, i8.NgForm, i9.Divider, i10.RadioButton, i8.NgControlStatus, i8.NgModel, i11.Dropdown, i12.Table, i13.PrimeTemplate, i12.TableRadioButton, i8.DefaultValueAccessor, i14.InputText, i8.RequiredValidator, i15.ButtonDirective, i7.NgClass], styles: [".type-of-office-label[_ngcontent-%COMP%]{margin-bottom:0;margin-left:4px}.each-office-type[_ngcontent-%COMP%]{margin:0 8px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsulateAddressLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'consulate-address-library',
                templateUrl: 'consulate-address-library.component.html',
                styleUrls: ['consulate-address-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.ToastrService }, { type: i3.APIConsulateAddress }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.CacheCountryListService }, { type: i6.AppServicesLibraryService }]; }, { processingInformationForm: [{
            type: ViewChild,
            args: ['processingInformationForm', { static: true }]
        }], primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], isWizard: [{
            type: Input
        }] }); })();

class ConsulateAddressLibraryModule {
}
ConsulateAddressLibraryModule.ɵfac = function ConsulateAddressLibraryModule_Factory(t) { return new (t || ConsulateAddressLibraryModule)(); };
ConsulateAddressLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: ConsulateAddressLibraryModule });
ConsulateAddressLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseConsulateAddressLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ConsulateAddressLibraryModule, { declarations: [ConsulateAddressLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule], exports: [ConsulateAddressLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsulateAddressLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [ConsulateAddressLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                ],
                providers: [BaseConsulateAddressLibraryService],
                exports: [ConsulateAddressLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of consulate-address-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConsulateAddressLibraryComponent, ConsulateAddressLibraryModule, ConsulateAddressLibraryService };
//# sourceMappingURL=consulate-address-library.js.map
